(function () {
    'use strict';

    angular.module('swif.openbase')
        .factory('swifOpenbaseBANService', swifOpenbaseBANService);

    function swifOpenbaseBANService($q, swif) {
        'ngInject';
        var service = {};

        service.getLastSynchronisationDate = function () {
            /* Get synchronization date */
            return swif.collections.createOrUpdate('ban_updated_date', 'ban_updated_date', {})
        };

        service.getBANConnector = function () {
            if (swif.module.modules.opengst_ban) {
                return swif.data.get('ban_connector', 1).then(function (connector) {
                    return connector;
                });
            } else {
                return false;
            }
        };

        service.saveBANConnector = function (connector) {
            swif.data.save('ban_connector', 1, connector).then(function () {
                swif.message.addInfo('save ok');
            }, function (error) {
                swif.message.addError(error);
            });
        };

        service.synchronize = function (success) {
            swif.data.callKw(
                'ban_connector',
                'synchronize',
                [],
                {}
            ).then(success);
        };

        return service;
    }

})();
